import {Component, Element, h, Prop} from "@stencil/core";
import { _debug } from "../debugger/debugger";

@Component({
  tag: "m-internal-links",
  styleUrl: "./styles.scss",
  shadow: true
})
export class InternalLinks {

  @Element() host: HTMLElement;

  @Prop({ reflect: true }) label = "skiplinks";

  componentDidLoad() {
    let slottedLinks: HTMLAnchorElement[] = this.host.children as any as HTMLAnchorElement[];
  
    for (let link of slottedLinks) {
      link.setAttribute('role', 'list-item')
      link.onclick=((evt: Event)=> {
        _debug('this.host.parentNode.querySelector(link.getAttribute("href"))', this.host.parentNode.querySelector(link.getAttribute('href')))

        evt.preventDefault();
        (this.host.parentNode.querySelector(link.getAttribute('href')) as HTMLElement).focus()  
      })
    }
  }

  render() {
    return (
      <nav role="list" aria-label={ this.label }>        
          <slot />
      </nav>  
    )
  }
}
